import React from 'react';
import { motion } from 'framer-motion';
import { Typography, Container, Grid, Card, CardMedia, CardContent, Box } from '@mui/material';
import './OurProduct.css';

const products = [
  {
    id: 1,
    name: "Fuel Sensor",
    image: "/images/fuel-sensor.png",
    description: "Advanced fuel monitoring sensor for accurate fuel consumption tracking"
  },
  {
    id: 2,
    name: "Teltonika FMB910",
    image: "/images/fmb910.png",
    description: "Professional GPS tracking device with advanced features"
  },
  {
    id: 3,
    name: "Teltonika FMB920",
    image: "/images/fmb920.png",
    description: "High-performance GPS tracker with real-time monitoring"
  },
  {
    id: 4,
    name: "Teltonika FMB120",
    image: "/images/fmb120.png",
    description: "Compact GPS tracking device for fleet management"
  },
  {
    id: 5,
    name: "Teltonika FMB125",
    image: "/images/fmb125.png",
    description: "Advanced GPS tracker with extended functionality"
  },
  {
    id: 6,
    name: "GH5200 - Personal Tracker",
    image: "/images/gh5200.png",
    description: "Personal GPS tracking device for individual monitoring"
  },
  {
    id: 7,
    name: "TMT250 - Personal Tracker",
    image: "/images/tmt250.png",
    description: "Compact personal tracker with long battery life"
  }
];

const OurProduct = () => {
  return (
    <div className="products-page">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Container maxWidth="xl">
          <Box className="products-header">
            <Typography variant="h1" className="products-title">
              Our Key Product Ranges
            </Typography>
            <Typography variant="h5" className="products-subtitle">
              Cutting-edge GPS tracking solutions for every need
            </Typography>
          </Box>

          <Grid container spacing={4} className="products-grid">
            {products.map((product) => (
              <Grid item xs={12} sm={6} md={4} lg={4} key={product.id}>
                <motion.div
                  whileHover={{ y: -10 }}
                  transition={{ duration: 0.3 }}
                >
                  <Card className="product-card">
                    <CardMedia
                      component="img"
                      height="260"
                      image={product.image}
                      alt={product.name}
                      className="product-image"
                    />
                    <CardContent className="product-content">
                      <Typography variant="h6" className="product-name">
                        {product.name}
                      </Typography>
                      <Typography variant="body2" className="product-description">
                        {product.description}
                      </Typography>
                    </CardContent>
                  </Card>
                </motion.div>
              </Grid>
            ))}
          </Grid>

          <motion.div
            className="ais-devices-section"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            <Typography variant="h2" className="ais-title">
              Govt. Mandated AIS 140 Devices
            </Typography>
            
            <Grid container spacing={6} className="ais-devices-grid">
              <Grid item xs={12} md={6}>
                <motion.div
                  className="ais-device-card"
                  whileHover={{ scale: 1.02 }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  <div className="device-image-container">
                    <img src="/images/teltonika-fmb209.png" alt="Teltonika FMB209" />
                  </div>
                  <div className="device-content">
                    <Typography variant="h4" className="device-name">Teltonika FMB209</Typography>
                    <ul className="device-features">
                      <li>GNSS/GSM/IRNSS Terminal</li>
                      <li>Internal Li-ion Battery 3.8V 800mAh</li>
                      <li>AIS-140 Certified Device</li>
                      <li>Emergency SOS Button Support</li>
                    </ul>
                  </div>
                </motion.div>
              </Grid>

              <Grid item xs={12} md={6}>
                <motion.div
                  className="ais-device-card"
                  whileHover={{ scale: 1.02 }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  <div className="device-image-container">
                    <img src="/images/wetrack-140.png" alt="Wetrack 140" />
                  </div>
                  <div className="device-content">
                    <Typography variant="h4" className="device-name">Wetrack 140</Typography>
                    <ul className="device-features">
                      <li>AIS-140 Compliant GPS Tracker</li>
                      <li>Built-in Battery Backup</li>
                      <li>Real-time Vehicle Tracking</li>
                      <li>Panic Button Integration</li>
                    </ul>
                  </div>
                </motion.div>
              </Grid>
            </Grid>
          </motion.div>
        </Container>
      </motion.div>
    </div>
  );
};

export default OurProduct;
